import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Popover, Button, Tooltip, Icon } from "antd";
import { observable, action, computed } from "mobx";
import { TemplateModel } from "../../../../stores/TemplateModel";
import { observer } from "mobx-react";
import { notification } from "antd";

interface Props extends RouteComponentProps<any> {
  template: TemplateModel;
  onLoading: (isLoading: boolean) => void;
}

@observer
class DeleteTemplateAction extends React.PureComponent<Props, any> {
  @observable popoverVisible: boolean = false;
  @observable loading: boolean = false;

  @action setPopoverVisible = (visible: boolean) => {
    this.popoverVisible = visible;
  };

  @action onDelete = async (template: TemplateModel) => {
    if (this.loading) {
      return;
    }
    
    try {
      this.props.onLoading(this.loading = true);
      await template.delete();
      notification["success"]({
        message: "Delete template successful",
        description: ""
      });
    } catch (err) {}
    this.props.onLoading(this.loading = false);
  };

  @computed get icon() {
    return this.loading ? "loading" : "delete";
  }
  render() {
    const { template } = this.props;
    return (
      <>
        <Popover
          content={
            <div>
              <Button
                size="small"
                onClick={() => this.setPopoverVisible(false)}
                style={{ marginRight: 10 }}
                icon="stop"
              >
                cancel
              </Button>
              <Button
                type="danger"
                size="small"
                onClick={() => this.onDelete(template)}
                icon="delete"
              >
                ok
              </Button>
            </div>
          }
          title="Are you sure to delete?"
          trigger="click"
          visible={this.popoverVisible}
          onVisibleChange={visible => this.setPopoverVisible(visible)}
        >
          <Tooltip placement="bottomLeft" title={"Delete"}>
            <button
            //onClick={()=>onDelete(template)}
            >
              <Icon type={this.icon} />
            </button>
          </Tooltip>
        </Popover>
      </>
    );
  }
}
export default withRouter(DeleteTemplateAction);
